import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {X, XCircleFill} from "react-bootstrap-icons";

class SearchBar extends Component {
  state = { texto: "" };

  constructor(props) {
    super(props);
    this.timeout = 0;
  }

  componentDidMount() {
    this.updateTextoFromQuery();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.updateTextoFromQuery();
    }
  }

  updateTextoFromQuery = () => {
    const query = new URLSearchParams(this.props.location.search);
    const buscar = query.get("buscar") || "";
    if (buscar !== this.state.texto) {
      this.setState({ texto: buscar });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.doSearch();
  };

  handleChange = (e) => {
    this.setState({ texto: e.target.value });

    // Inicializa timeout para busqueda automática después de 1000ms
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.doSearch();
    }, 1000);
  };

  handleClear = () => {
    this.setState({ texto: "" }, () => {
      this.doSearch();
    });
  };

  doSearch = () => {
    let { texto } = this.state;
    let textoBuscar = texto;
    // this.setState({ texto: "" }); // Remove clearing the text
    this.props.history.push("/productos?buscar=" + textoBuscar);
    if (this.props.onSearch) this.props.onSearch(textoBuscar);
  };

  render() {
    return (
      <div className="searchBarContainer">
        <input
          className="inputBuscar"
          type="text"
          placeholder="Buscar productos"
          value={this.state.texto}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
        ></input>
        {this.state.texto && (
          <button className="clearSearchButton" onClick={this.handleClear}>
            <X style={{fontSize: "2.2rem"}} />
          </button>
        )}
      </div>
    );
  }
}

export default withRouter(SearchBar);
